import { render } from "./DepositAppMalawi.vue?vue&type=template&id=13a7e66f&scoped=true"
import script from "./DepositAppMalawi.vue?vue&type=script&lang=js"
export * from "./DepositAppMalawi.vue?vue&type=script&lang=js"

import "./DepositAppMalawi.vue?vue&type=style&index=0&id=13a7e66f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a7e66f"]])

export default __exports__